module.exports = __webpack_public_path__ + "static/media/Egg.6eedeae0.png";